module.exports = __webpack_public_path__ + "img/success-96.5df63ba4.svg";